import { CommonModule } from "@angular/common";
import { Component, Input, ViewEncapsulation } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import type { InviteWizardComponent } from "./invite-wizard.component";

@Component({
  selector: "app-invite-wizard-profile-steps",
  templateUrl: "./invite-wizard-profile-steps.component.html",
  styleUrls: [
    "../wizard/wizard.component.layout-and-progress.scss",
    "../wizard/wizard.component.preferences-and-responsive.scss"
  ],
  encapsulation: ViewEncapsulation.None,
  host: { style: "display: contents" },
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  standalone: true
})
export class InviteWizardProfileStepsComponent {
  @Input({ required: true }) view!: InviteWizardComponent;
}
